<style lang="less">
    .top_con{
        width:100%;
        height:1.96rem;
        padding:0 .2rem;
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .logo{
            width:3.6rem;
            height:auto;
            margin-top:.2rem;
            display: block;
        }
        .name{
            width:3rem;
            height:auto;
            display: block;
        }
        .logo-day{
            display: block;
            font-size: .2rem;
            position: absolute;
            top: 0.5rem;
            left: 2.95rem;
            z-index: 11;
            text-align: center;
            width: .3rem;
        }
        .userinfo{
            font-size: .3rem;
            color:#F47381;
            position: absolute;
            top: 0.45rem;
            right: 1.2rem;
            z-index: 11;
        }
    }
    .content{
        width:100%;
        height:calc(100% - 1.96rem);
        // background: url("../assets/images/tree-phone.png") no-repeat;
        // background-size:100% 100%;
        position: fixed;
        left:0;
        bottom:0;
        z-index: 13;
        >div{
            width:auto;
            height:100%;
            position: relative;
            .tree{
                width:6rem;
                height:90%;
                display: block;
                // margin:0 auto;
                position: absolute;
                left:50%;
                bottom: 0;
                z-index: 1;
                transform: translateX(-50%);
            }
            .bird{
                width:1rem;
                height:auto;
                display: block;
                position:absolute;
                left: 19%;
                top:23%;
                z-index: 22;
            }
            a{
                color:#fff;
                position: absolute;
                z-index: 111;
            }
            a>img{
                width:100%;
                height:auto;
                display: block;
            }
            .artical{
                width: 4rem;
                height: auto;
                left: 24%;
                bottom: 82%;
                font-size: .6rem;
            }
            .story{
                width: 2.3rem;
    left: 62%;
    bottom: 60%;
            }
            .score{
                left: 62%;
                bottom: 73%;
                font-size: 0.4rem;
                width: 2.2rem;
            }
            .game{
                width: 2.3rem;
                left: 5.5%;
                bottom: 47%;
                font-size: 0.48rem;
            }
            .rank{
                left: 64%;
                width: 2.6rem;
                bottom: 44%;
                font-size: 0.48rem;
            }
            .redo{
                left: 6%;
                bottom: 26%;
                font-size: 0.5rem;
                width: 2.2rem;
            }
            .bye{
                left: 56%;
                bottom: 23%;
                font-size: 0.36rem;
                width: 2rem;
            }
        }
    }
    .bottom_con{
        width:100%;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 1;
        img{
            width:100%;
            height:auto;
            display:block;
        }
        img.art_bottom_flowers{
            width:1.2rem;
            height:auto;
            display: block;
            position: absolute;
            left: .3rem;
            bottom:0;
            z-index: 11;
        }
        img.art_bottom_sunflowers{
            width:1.8rem;
            height:auto;
            display: block;
            position: absolute;
            right: 0rem;
            bottom:.1rem;
            z-index: 11;
        }
    }
</style>
<template>
    <div class="page_con">
        <div class="top_con">
            <img class="logo" src="../assets/images/logo-pc.png" alt="">
            <img class="name" src="../assets/images/user-pc.png" alt="">
            <div class="logo-day">{{date}}</div>
            <div class="userinfo">
                <p>姓名：{{$store.getters.userInfo.Name}}</p>
                <p>班级：{{$store.getters.userInfo.GradesName}}</p>
            </div>
        </div>
        <div class="content">
            <div>
                <img class="tree" src="../assets/images/tree-phone.png" alt="">
                <!-- <img class="bird" src="../assets/images/bird-phone.png" alt=""> -->

                <router-link class="artical" to="/artical"><img src="../assets/images/read.png" alt=""></router-link>
                <router-link class="story" to="/story"><img src="../assets/images/listen.png" alt=""></router-link>
                <router-link class="score" to="/score"><img src="../assets/images/score.png" alt=""></router-link>
                <router-link class="game" to="/play"><img src="../assets/images/play.png" alt=""></router-link>
                <router-link class="rank" to="/rank"><img src="../assets/images/rank.png" alt=""></router-link>
                <router-link class="redo" to="/redo"><img src="../assets/images/again.png" alt=""></router-link>
                <a class="bye" @click="logout" href="javascript:;"><img src="../assets/images/goodbye.png" alt=""></a>
            </div>
        </div>
        <div class="bottom_con">
            <img src="../assets/images/bg3-phone.png" alt="">
            <img class="art_bottom_flowers" src="../assets/images/flowers.gif" alt="">
            <img class="art_bottom_sunflowers" src="../assets/images/sunflower.gif" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            date:'',
        }
    },
    mounted(){
        this.getDay();
        let vm = this;
        this.$http.get(this.baseUrl+'/Read/index.html?rest_key=1').then(res=>{
            if(!res.data.data.user.Name){
                vm.$router.push('/login');
            }
        })
    },
    methods:{
        getDay(){
            this.date = new Date().getDate();
        },
        logout(){
            let vm = this;
            this.$http.get(this.baseUrl+'/User/logout.html?rest_key=1').then(res=>{
                console.log(1111);
                vm.$router.push('/login');
            }).catch(err=>{
                console.log(333);
                vm.$router.push('/login');
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index.vue